import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * 树结构数据处理函数
 * @module $ui/utils/tree
 */

/**
 * 列表转换树结构
 * @param {Object[]} list 列表数据，约定字段名称： id/parentId/children
 * @param {*} [parentId=null] 父节点的值
 * @param {string} [idKey=id] id字段名称
 * @param {string} [parentIdKey=parentId] parentId字段名称
 * @return {Array}
 */
export function create() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var idKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  var parentIdKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'parentId';
  var temp = Object.create(null);
  var tree = [];
  list.forEach(function (item) {
    temp[item[idKey]] = _objectSpread({}, item);
  });
  Object.keys(temp).forEach(function (key) {
    var item = temp[key];
    if (item[parentIdKey] === parentId) {
      tree.push(item);
    } else {
      var parent = temp[item[parentIdKey]];
      if (parent) {
        if (!parent.children) {
          parent.children = [];
        }
        parent.children.push(item);
      }
    }
  });
  return tree;
}

/**
 * 树结构数据相辅助函数
 * @module $ui/utils/tree
 */

/**
 * 遍历树数据节点，查找符合条件的节点
 * @param {Array|Object} data 数据树，如 {id:1, children:[{id:2}]}
 * @param {Boolean} isFindOne 是否只找最先符合条件的一个
 * @param {Function} fn 查找回调函数，回调参数：item 节点，index节点当前兄弟节点中的索引，data 查找的数据树，函数返回true表示符合条件
 * @param {string} [field=children] 子级字段名称
 * @returns {Array|Object} 查找结果，isFindOne为true时返回Object， false时返回Array
 */
export function find() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isFindOne = arguments.length > 1 ? arguments[1] : undefined;
  var fn = arguments.length > 2 ? arguments[2] : undefined;
  var field = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'children';
  var result = [];
  data = Array.isArray(data) ? data : [data];
  for (var i = 0, len = data.length; i < len; i++) {
    var item = data[i];
    var checked = fn(item, i, data);
    var children = item[field];
    if (checked) {
      result.push(item);
      if (isFindOne) break;
    }
    if (children) {
      var child = find(children, isFindOne, fn, field);
      if (child) result = result.concat(child);
    }
  }
  return isFindOne ? result[0] || null : result;
}

/**
 * 查找节点在树结构数组的路径
 * @param {Array|Object} data 树数据数组， 如 {id:1, children:[{id:2}]}
 * @param {Function} fn 查找回调函数，回调参数：item 节点，index节点当前兄弟节点中的索引，data 查找的数据树，函数返回true表示符合条件
 * @param {string} [field=children] 子级字段名称
 * @return {Array} 节点路径数组
 */
export function findPath(data, fn) {
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  var path = [];
  function find(array, parent) {
    parent && path.push(parent);
    for (var i = 0, len = array.length; i < len; i++) {
      var item = array[i];
      var checked = fn(item, i, array);
      var children = item[field];
      // 找到，记录路径，退出循环
      if (checked) {
        path.push(item);
        return true;
      }
      if (children && children.length > 0) {
        // 在子级找到，退出循环，自己没有，删除记录的父级
        if (find(children, item)) {
          return true;
        } else {
          path.pop();
        }
      }
    }
  }
  find([].concat(data));
  return path;
}